import React, { FC }       from "react";
import { useStore }        from "react-redux";
import { Table }           from "semantic-ui-react";
import Staff               from "../../../domain/staff/Staff";
import Staffs              from "../../../domain/staff/Staffs";
import TopSection          from "../common/layout/TopSection";
import StaffDeleteButton   from "./StaffDeleteButton";
import StaffEditButton     from "./StaffEditButton";
import StaffRegisterButton from "./StaffRegisterButton";

const StaffList: FC = () => {
  const staffs: Staffs = useStore().getState().staffs;

  return (
    <>
      <TopSection>
        <StaffRegisterButton/>
      </TopSection>

      {
        staffs.isEmpty() ? <p>まだスタッフのアカウントが作成されていません。</p> :
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>スタッフ名</Table.HeaderCell>
                <Table.HeaderCell>操作</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                staffs.toList().map((staff: Staff) => (
                  <>
                    <Table.Row>
                      <Table.Cell>
                        { `${ staff.name.lastName.value } ${ staff.name.firstName.value }` }
                      </Table.Cell>
                      <Table.Cell>
                        <StaffEditButton staff={ staff }/>
                        <StaffDeleteButton staff={ staff }/>
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))
              }
            </Table.Body>
          </Table>
      }
    </>
  );
};

export default StaffList;
